export const initialState = () => {
  return {
    /*
     *  TRANSLATIONS
     */
    webp: false,
    webpRendered: false,
    language: '',

    translations: {
      general: {
        nl: {
          title: 'De Beer en zijn sjaal',
          presskit: 'Download perskit',
          home: 'Startscherm',
          share: 'Deel dit verhaal op',
          or: 'of',
          share_label: 'Deel'
        },
        fr: {
          title: 'L’Ours et son écharpe',
          presskit: 'Telecharger le kit de presse',
          home: 'Ecran d’accueil',
          share: 'Partager cette histoire sur',
          or: 'et',
          share_label: 'Share'
        },
        en: {
          title: 'The Bear and his Scarf',
          presskit: 'Download press kit',
          home: 'Start screen',
          share: 'Share this story on',
          or: 'and',
          share_label: 'Share'
        }
      },
      outro: {
        nl: {
          text: '© Club Brugge, 2019 <br>Uitgever <br>Club Bruges NV Herenweg 9, <br>8300 Knokke <br> <br><a class="e-link" href="https://www.lucyagency.com/" rel="noopener" target="_blank">lucyagency.com</a> <br>Tekst: Ruben Van Maldeghem en Jonas Marysse <br>Illustraties: <a class="e-link" href="http://www.julievanhove.com/" target="_blank">Julie van Hove</a> <br>Website: <a href="https://www.grovelust.be/" rel="noopener" target="_blank" class="e-link">grovelust.be</a>',
          download: 'Download',
          presskit: 'perskit'
        },
        en: {
          text: '© Club Bruges, 2019 <br>Publisher <br>Club Bruges NV Herenweg 9, <br>8300 Knokke <br> <br><a class="e-link" href="https://www.lucyagency.com/" rel="noopener" target="_blank">lucyagency.com</a> <br>Text: Ruben Van Maldeghem and Jonas Marysse <br>Illustrations: <a class="e-link" href="http://www.julievanhove.com/" target="_blank">Julie van Hove</a> <br>Website: <a href="https://www.grovelust.be/" rel="noopener" target="_blank" class="e-link">grovelust.be</a>',
          download: 'Download',
          presskit: 'press kit'
        },
        fr: {
          text: '© Club de Bruges, 2019 <br>Éditeur <br>Club de Bruges NV Herenweg 9, <br>8300 Knokke <br> <br><a class="e-link" href="https://www.lucyagency.com/" rel="noopener" target="_blank">lucyagency.com</a> <br>Texte: Ruben Van Maldeghem et Jonas Marysse <br>Illustrations: <a class="e-link" href="http://www.julievanhove.com/" target="_blank">Julie van Hove</a> <br>Site web: <a href="https://www.grovelust.be/" rel="noopener" target="_blank" class="e-link">grovelust.be</a>',
          download: 'Telecharger',
          presskit: 'le kit de presse'
        }
      },
      intro: {
        nl: {
          text: '‘De Beer en zijn sjaal’ is een voorleesverhaal over clubliefde en respect. </br>Het is een duidelijk statement tegen hooliganisme en racisme. </br>Met dit kinderboek voor groot en klein wil Club Brugge </br>samen met zijn supporters het goede voorbeeld geven. </br>Veel (voor)leesplezier!',
          cta: 'Scroll en ontdek het verhaal'
        },
        en: {
          text: '‘The Bear and his Scarf’ is a story about club love and respect. It is a clear statement against hooliganism and racism. With this children’s book for both adults and children, Club Bruges and its supporters want to lead by example. </br>Enjoy the story!',
          cta: 'Scroll and discover the story'
        },
        fr: {
          text: "‘L’Ours et son écharpe’ est une histoire sur le respect et l’amour que l’on porte à son club. C'est une déclaration claire contre le hooliganisme et le racisme. Avec ce livre pour enfant pour les petits et les grands, le Club de Bruges veut donner le bon exemple à ses supporters. </br>Bonne lecture !",
          cta: 'Deroulez et decouvrez l’histoire'
        }
      },
      afterword: {
        nl: {
          sidebar: 'Nawoord',
          title: '‘De Beer en zijn sjaal’ is een verhaal over Clubliefde ...',
          text: '... maar nog meer over clubliefde. Met een kleine c dus. Want meer dan een verhaal over Club Brugge is ‘De Beer en zijn sjaal’ een verhaal over respect. Respect voor elkaar, voor de tegenstander en voor de supporters van de tegenstander. Iedereen ziet zijn ploeg, zijn kleuren en zijn mascotte het liefst. Net die passie voor een club en voor het voetbal hebben we met mekaar gemeen. We zijn met elkaar verbonden door clubliefde. Clubliefde mag en kan dus geen excuus zijn voor onaanvaardbaar gedrag zoals hooliganisme en racisme. Met dit voorleesboek wil Club Brugge zijn toekomstige en huidige generatie supporters oproepen om het goede voorbeeld te geven in en rond de Belgische voetbalstadions en alle andere plekken waar clubliefde tot uiting komt. Het is ook een warme oproep naar alle andere clubs en supporters om deze boodschap mee uit te dragen. Want door er met z’n allen telkens weer een voetbalfeest van te maken, kan iedereen voluit genieten van zijn of haar club. Zo blijft voetbal de belangrijkste en mooiste bijzaak van de wereld. </br></br>Veel (voor)leesplezier,',
          subword: 'Voorzitter van Club Brugge K.V.'
        },
        en: {
          sidebar: 'Afterword',
          title: '‘The Bear and His Scarf’ is a story about the love for Club...',
          text: '... but even more about the love for one’s club. Without a capital C. ‘The Bear and His Scarf’ is a story about respect, more than about Club Bruges. Respect for each other, for the opponent and for the opponent’s supporters. We all prefer our own team, our own colours and our own mascot. We have this passion for a club and for football in common. We’re connected through club love. But this should never be an excuse for unacceptable behaviour like hooliganism and racism. With this book, Club Bruges would like to call on its future and current generations of supporters to set the right example in and around the football stadiums in Belgium and all other places where club love is expressed. It’s also a friendly call to all other clubs and supporters to help us convey this message. Because if we work together to make football fun, everyone can enjoy his or her club. And ensuring that football remains the most important and most beautiful sport in the world. </br></br>Have fun reading this story,',
          subword: 'Chairman of Club Bruges K.V.'
        },
        fr: {
          sidebar: 'Epilogue',
          title: '« L’Ours et son echarpe » est une histoire sur l’amour du Club ...',
          text: '... mais surtout sur l’amour pour son club. Avec un c minuscule donc. « L’Ours et son écharpe » est bien plus qu’une histoire du Club de Bruges, on y parle aussi de respect. Le respect mutuel, pour son adversaire et pour les supporters de l’équipe adverse. Bien sûr, chacun préfère son équipe, ses couleurs et sa mascotte. C’est cette passion pour un club et pour le football que nous partageons. C’est cet amour pour son club qui nous unit. En aucun cas cet amour ne peut et ne doit servir d’excuse pour des comportements inacceptables tels que le hooliganisme ou le racisme. À l’aide de cette histoire, le Club de Bruges incite ses futurs supporters, ainsi que la génération actuelle, à donner le bon exemple dans et en dehors des stades de foot, ainsi que tout autre endroit où l’on peut exprimer son amour pour son club. C’est aussi une invitation chaleureuse envoyée à tous les clubs et supporters à partager ce message. Car c’est uniquement en transformant ces rencontres sportives en véritables festivités que chacun peut apprécier le match ainsi que son propre club. Ainsi, le football reste ce qu’il y a de plus important et de plus beau au monde. </br></br>Bonne lecture !',
          subword: 'Président du Club de Bruges K.V.'
        }
      },
      scenes: {
        en: {
          1: {
            top: ['It’s a special day for baby Bear today.',
              'He’s off to the football match for the very first time, to watch his club play.',
              '<span class="is-indent"></span>‘Let’s go,’ says daddy Bear. ‘Or we’ll be late!’',
              '‘I’ve got you a present,’ calls mommy Bear, ‘Wait.’',
              '<span class="is-indent"></span>It’s a scarf. With blue and black, so pretty.',
              '‘My favourite colours!’ baby Bear shouts excitedly.'],
            bottom: ['He looks at himself in the mirror, proud and strong.',
              '<span class="is-indent"></span>Daddy Bear laughs,',
              '<span class="is-indent"></span><span class="is-large">‘Hurry up now, come along.’</span>']
          },
          2: {
            left: ['They meet Rabbit in the woods.',
              'He’s wearing a scarf too. Good!',
              '<span class="is-indent"></span>‘Shall we say hi?’ baby Bear asks happily.',
              '<span class="is-indent"></span>‘No! Rabbit’s trouble, believe me!',
              '<span class="is-indent"></span>He digs holes in our field, very unpleasant,’',
              'daddy Bear grunts.',
              '<span class="is-indent"></span>‘Look at his scarf, <span class="is-large">the colours are different.’</span>'],
            right: ['<span class="is-large">‘Come along, quickly,’</span> daddy Bear says straight-faced.',
              '‘We don’t want to miss it; we’d better make haste.’']
          },
          3: {
            top: ['The wind blows daddy’s scarf up into the sky.',
              'It’s stuck in a tree, way up high.',
              '<span class="is-spacer"></span>',
              '‘Now what?’ daddy Bear asks with a bit of a howl.',
              '‘I know who can get your scarf,’ baby Bear calls. ‘Owl!’',
              '<span class="is-indent"></span>‘And why would I do that?’ Owl says, slightly vain.',
              '<span class="is-indent"></span>‘That scarf is very important to us,’ baby Bear explains.',
              '<span class="is-indent"></span>‘I’ll help you, but just this once, you see.’',
              'And he tosses the scarf down from the tree.',
              '<span class="is-indent"></span>‘I like Owl,’ baby Bear says cheerfully after a moment.',
              '<span class="is-indent"></span>‘Well you shouldn’t,’ grumbles daddy Bear.',
              '‘Look at his scarf, <span class="is-large">the colours are different.’</span>',
              '<span class="is-spacer"></span>',
              '<span class="is-indent"></span><span class="is-large">‘Come on, let’s go!’</span> daddy Bear says swiftly.',
              '<span class="is-indent"></span>‘Or we’ll miss the match, definitely.’']
          },
          4: {
            top: ['There’s Zebra, racing by with a steady tread.',
              'Now a question pops up in baby Bear’s head.',
              '<span class="is-indent"></span>‘Daddy, is Zebra black? Or is he white?’',
              '<span class="is-indent"></span>‘Euh...’ daddy Bear says, thinking with all his might.',
              '<span class="is-spacer"></span>',
              '<span class="is-indent"></span>‘Good question,’ Zebra mutters with a pensive note.',
              '‘I don’t really think about it, this is simply my coat.',
              'You decide. Black or white, it doesn’t matter to me.’',
              '<span class="is-indent"></span>‘Your skin is your skin,’ says baby Bear. ‘That’s what I see.’',
              '<span class="is-indent"></span>‘That wasn’t wise!’ daddy Bear says with a grunt.',
              '<span class="is-indent"></span>‘Look at his scarf. <span class="is-large">The colours are different.’</span>'],
            bottom: ['<span class="is-large">‘Let’s go,’ </span> says daddy Bear. <span class="is-large">‘We’d better run.</span>',
              'Or we’ll be late and miss all the fun.’']
          },
          5: {
            left: ['<span class="is-indent"></span><span class="is-large">‘Help!’</span>',
              '<span class="is-indent"></span><span class="is-large">‘Help!’</span>',
              'What does baby Bear hear?',
              '<span class="is-indent"></span><span class="is-large">‘Help!’</span>',
              'Someone’s calling in fear.',
              'Baby Buffalo comes running.',
              '<span class="is-indent"></span><span class="is-large">‘Help!</span> My daddy’s blind! He can’t see a thing!’'],
            right: ['Buffalo’s eyes are covered with leaves, twigs and thorns.',
              'The wind has blown them right onto his horns.',
              'Daddy Bear laughs at this strange sight.',
              'But daddy Buffalo is downright terrified.',
              '<span class="is-indent"></span>‘Come,’ baby Bear says. ‘I’ll help you out of this jam.',
              '<span class="is-indent"></span>There, Buffalo. Now you can see again!’',
              '‘Don’t help Buffalo!’ daddy Bear growls very insistent.',
              '<span class="is-indent"></span>‘Look at his scarf. <span class="is-large">The colours are different.’</span>',
              '<span class="is-spacer"></span>',
              '<span class="is-indent"></span><span class="is-large">‘Come on, let’s go. </span> We can’t wait.',
              '<span class="is-indent"></span>All this talk will make us late.’']
          },
          6: {
            top: ['The bears suddenly hear shouting by the river ahead.',
              '<span class="is-indent"></span><span class="is-large">‘The bridge is broken!’</span>',
              'the animals are yelling, clearly upset.',
              'No one can get to their match; things are getting heated.',
              'The animals are arguing, they all look defeated.']
          },
          7: {
            top: ['<span class="is-indent"></span>‘I’m angriest!’',
              'Peacock calls with a scarf in purple and white.',
              '‘My team is the best, I’m certainly right.’',
              '<span class="is-indent"></span>‘No way!’ calls Rooster, his scarf white and red.',
              '‘My team plays with passion, that much can be said.’',
              '<span class="is-spacer"></span>',
              'All the animals bicker and shout.',
              'They gesture, argue and cry out.',
              'They’re ready to charge, these growlers.',
              '<span class="is-indent"></span>Look at their scarves, <span class="is-large">all those different colours.</span>']
          },
          8: {
            top: ['‘How can we get to the match',
              'when things look so bleak?’',
              '<span class="is-indent"></span>baby Bear <span class="is-large">sobs.</span>',
              '<span class="is-indent"></span>A tear rolling down his cheek.']
          },
          9: {
            top: ['But then daddy Bear has an idea.',
              '<span class="is-indent"></span><span class="is-large">‘Stop!’</span> he roars. ‘Listen to me!',
              'All this time I’ve been placing the blame.',
              'But now I see were all the same.’',
              '<span class="is-spacer"></span>',
              '<span class="is-indent"></span>‘I’m not like Canary!’ proud Peacock calls out resolutely.',
              '‘Look at you!’ daddy Bear says. ‘You’re both equally angry, surely.’',
              '<span class="is-indent"></span>‘I don’t have horns like Buffalo!’ Rabbit yells hastily.',
              '‘But you’re both wearing scarves,’ daddy Bear says. ‘As you can see.’',
              '‘The different colours aren’t a taunt.',
              'It’s all the same thing that we want.',
              '<span class="is-indent"></span>Every animal, every beast, wants to go to their football feast.’'],
            bottom: ['The animals look each other up and down.',
              '<span class="is-indent"></span><span class="is-large">‘Bear, what you say is true,’</span> they frown.']
          },
          10: {
            top: ['Baby Bear says ‘We need to work together as one.',
              'Take off your scarf and pass it along.',
              'We’ll tie them together and work as a team.’',
              '<span class="is-indent"></span>And that’s how all the animals cross the stream.'
            ],
            bottom: ['<span class="is-indent"></span>Everyone’s feeling light of heart.',
              'Just in time for the match to start.',
              'Believe it or not but everyone',
              'wishes each other <span class="is-large">lots of fun.</span>']
          },
          11: {
            top: ['<span class="is-indent"></span>‘So, the other colours aren’t so bad?’',
              'baby Bear asks softly.',
              '<span class="is-indent"></span>‘No,’ daddy Bear says. Baby Bear smiles with glee.',
              '‘Everyone loves their own scarf,that’s how they see it.’',
              'Daddy Bear grins,',
              '‘But <span class="is-large">blue and black</span> are still my favourite.’']
          },
          12: {
            top: ['‘We made it! Just in time,',
              'though I feared we wouldn’t be.',
              '<span class="is-indent"></span>Welcome, baby Bear,',
              'to the <span class="is-large">football party!’</span>']
          }
        },
        nl: {
          1: {
            top: ['Het is een bijzondere dag voor kleine Beer.',
              'Hij gaat naar het voetbal, zijn eerste keer.',
              '<span class="is-indent"></span>‘We vertrekken,’ zegt papa Beer. ‘Ik ben al klaar!’',
              '<span class="is-indent"></span>‘Wacht,’ roept mama Beer.',
              '‘Ik heb nog een cadeautje, open maar!’',
              '<span class="is-indent"></span>Het is een sjaal. Zo mooi, met blauw en zwart.',
              '‘Mijn lievelingskleuren!’ roept kleine Beer, recht uit het hart.'],
            bottom: ['Kijk hoe fier hij voor de spiegel staat.',
              '<span class="is-indent"></span><span class="is-large">‘Kom,’</span> lacht papa Beer.',
              '<span class="is-indent"></span>‘Straks komen we nog te laat.’']
          },
          2: {
            left: [' In het bos zien ze Konijn.',
              'Hij draagt ook een sjaal. Wat fijn!',
              '<span class="is-indent"></span>‘Gaan we dag zeggen?’ vraagt kleine Beer blij.',
              '<span class="is-indent"></span>‘Nee! Met Konijn heb je alleen maar last, geloof mij!',
              'Hij graaft putten in het veld, vlak voor onze deur,’',
              'bromt papa Beer.',
              '<span class="is-indent"></span>‘Kijk naar zijn sjaal, <span class="is-large">die heeft een andere kleur.’</span>'],
            right: ['<span class="is-large">‘Kom, we lopen vlug door,’</span> zegt papa Beer beslist.',
              '‘Ik wil niet dat je iets van de wedstrijd mist.’']
          },
          3: {
            top: [' De wind blaast papa’s sjaal weg met een boog.',
              'Zijn sjaal hangt nu in een boom, heel hoog.',
              '<span class="is-spacer"></span>',
              '‘Wat nu?’ vraagt papa Beer en ze denken even.',
              '‘Bosuil!’ roept kleine Beer. ‘Hij kan je sjaal teruggeven.’',
              '<span class="is-indent"></span>‘Waarom zou ik dàt doen?’ zegt Bosuil, borst vooruit.',
              '<span class="is-indent"></span>‘De sjaal betekent veel voor ons,’ legt kleine Beer uit.',
              '<span class="is-indent"></span>‘Vooruit dan, het is goed voor deze ene keer.’',
              'En hij gooit de sjaal naar papa Beer.',
              '<span class="is-indent"></span>‘Ik vind Bosuil leuk,’ zegt kleine Beer met een goed humeur.',
              '<span class="is-indent"></span>‘Nee dat mag niet, ’ bromt papa Beer.',
              '‘Kijk naar zijn sjaal, <span class="is-large">die heeft een andere kleur.’</span>',
              '<span class="is-spacer"></span>',
              '<span class="is-indent"></span><span class="is-large">‘Kom, we lopen door!’</span> zegt papa Beer snel.',
              '<span class="is-indent"></span>‘Zo missen we zeker niets van het spel.’']
          },
          4: {
            top: ['Daar zien ze Zebra, hij loopt in galop.',
              'Nu zit kleine Beer met een vraag in zijn kop.',
              '<span class="is-indent"></span>‘Papa, is Zebra wit? Of toch meer zwart?’',
              '<span class="is-indent"></span>‘Euh ...’ zegt papa Beer en hij denkt heel hard.',
              '<span class="is-spacer"></span>',
              '<span class="is-indent"></span>‘Dat is een goede vraag,’ mompelt Zebra zacht.',
              '‘Ik denk er niet over na, mijn vacht is mijn vacht.',
              'Kies jij maar. Zwart of wit, mij maakt het niet uit.’',
              '<span class="is-indent"></span>‘Mij ook niet,’ zegt kleine Beer. ‘Je huid is je huid.’',
              '<span class="is-indent"></span>‘Dat was niet slim,’ bromt papa Beer. ‘Je weet niet wat er kan gebeuren.',
              '<span class="is-indent"></span>Kijk naar zijn sjaal, <span class="is-large">die heeft andere kleuren.’</span>'],
            bottom: ['<span class="is-large">‘Kom,’</span> zegt papa Beer. <span class="is-large">‘We lopen snel voort.’</span>',
              '‘Straks zijn we te laat en is er gescoord.’']
          },
          5: {
            left: ['<span class="is-indent"></span><span class="is-large">‘Help!’</span>',
              '<span class="is-indent"></span><span class="is-large">‘Help!’</span>',
              'Vanwaar komt dat geluid?',
              '<span class="is-indent"></span><span class="is-large">‘Help!’</span>',
              'Klinkt het nu heel luid.',
              'Het is kleine Buffel. Hij rent naar kleine Beer.',
              '<span class="is-indent"></span><span class="is-large">‘Help!</span>  Mijn papa is blind! Hij ziet niets meer!’'],
            right: ['Papa Beer ziet wat het is en lacht zich een kriek.',
              'Maar papa Buffel, die is in paniek.',
              'Er hangen takken en bladeren, recht voor zijn ogen.',
              'Die zijn door de wind op zijn hoorns gevlogen.',
              '<span class="is-indent"></span>‘Ik help je wel even,’ zegt kleine Beer.',
              '<span class="is-indent"></span>‘Ziezo, Buffel. Nu zie je weer!’',
              '‘Je moet Buffel niet helpen!’ bromt papa Beer.',
              '‘Ik wil niet blijven zeuren.',
              '<span class="is-indent"></span>Maar kijk naar zijn sjaal, <span class="is-large">die heeft andere kleuren.’</span>',
              '<span class="is-spacer"></span>',
              '<span class="is-indent"></span><span class="is-large">‘Kom! We gaan verder.</span> Want met al dat gepraat,',
              '<span class="is-indent"></span>komen we straks nog te laat.’']
          },
          6: {
            top: [' Plots horen de beren gebrul, vlakbij de rivier.',
              '<span class="is-indent"></span><span class="is-large">‘De brug is kapot!’</span> roept bijna elk dier.',
              'Niemand kan naar zijn match, het hele bos is kwaad.',
              'Iedereen maakt ruzie, niemand weet raad.']
          },
          7: {
            top: ['<span class="is-indent"></span>‘Ik ben het meeste boos!’',
              'roept Pauw met paars en witte sjaal.',
              '‘Mijn ploeg is de beste, beter dan jullie allemaal.’',
              '<span class="is-indent"></span>‘Niets van!’ roept Haan met zijn sjaal rood en wit.',
              '‘Mijn ploeg is de beste, wij spelen met pit.’',
              '<span class="is-spacer"></span>',
              'Alle dieren roepen en maken wilde gebaren.',
              'Nog even en ze vliegen elkaar in de haren.',
              'Ze lijken klaar om elkaar te verscheuren.',
              '<span class="is-indent"></span>Kijk naar hun sjaals, <span class="is-large">al die verschillende kleuren.</span>']
          },
          8: {
            top: [' ‘Hoe moeten we nu naar onze match gaan?’',
              '<span class="is-indent"></span><span class="is-large">snikt kleine Beer.</span>',
              '<span class="is-indent"></span>Over zijn wang rolt een traan.']
          },
          9: {
            top: [' Maar dan krijgt papa Beer een idee.',
              '<span class="is-indent"></span><span class="is-large">‘Stop!’</span> brult hij. ‘Luister even mee!’',
              '<span class="is-spacer"></span>',
              '‘Al de hele tijd probeer ik jullie te ontwijken.',
              'Maar nu zie ik dat we sterk op elkaar lijken.’',
              '<span class="is-indent"></span>‘Ik ben toch niet als Kanarie!’ roept fiere Pauw kordaat.',
              '‘Kijk dan!’ zegt papa Beer. ‘Jullie zijn allebei even kwaad.’',
              '<span class="is-indent"></span>‘Ik heb toch geen hoorns als Buffel!’ roept Konijn met veel kabaal.',
              '‘Kijk dan!’ zegt papa Beer. ‘Jullie dragen allebei een sjaal.’',
              '‘Ze mogen dan wel van kleur verschillen,',
              'toch zijn we hetzelfde in wat we willen.',
              '<span class="is-indent"></span>Elk dier en elk beest, wil gewoon naar zijn eigen voetbalfeest.’'],
            bottom: ['De dieren kijken nu eens heel goed naar elkaar.',
              '<span class="is-indent"></span>En zeggen dan: <span class="is-large">‘Beer, eigenlijk ... is dat waar.’</span>']
          },
          10: {
            top: ['‘Laten we samenwerken,’ stelt kleine Beer voor.',
              'Doe allemaal jullie sjaal uit en geef hem door.’',
              'We knopen ze aan elkaar, over de rivier.’',
              '<span class="is-indent"></span>Zo raken ze aan de overkant, dier per dier.’'],
            bottom: ['<span class="is-indent"></span>Iedereen is weer goedgezind.',
              'Net op tijd voor de match begint.',
              'Ze roepen nog – raar maar waar –',
              '<span class="is-large">‘Veel plezier!’</span> naar elkaar.']
          },
          11: {
            top: ['<span class="is-indent"></span>‘De andere kleuren zijn dus toch niet zo erg?’',
              'vraagt kleine Beer zacht.',
              '<span class="is-indent"></span>‘Nee,’ zegt papa Beer. En kleine Beer lacht.',
              '‘Iedereen houdt van zijn eigen sjaal, dat zorgt voor sfeer.',
              'Maar <span class="is-large">blauw met zwart</span> blijft het mooist,’',
              'grijnst papa Beer.']
          },
          12: {
            top: ['‘We zijn er! Net op tijd,',
              'al had ik er even voor gevreesd.',
              '<span class="is-indent"></span>Welkom kleine Beer,',
              'op het <span class="is-large">grote voetbalfeest!’</span>']
          }
        },
        fr: {
          1: {
            top: ['Aujourd’hui est un jour particulier que Petit Ours n’oubliera pas.',
              'Il va au foot pour la toute première fois !',
              '<span class="is-indent"></span>« C’est parti ! » dit Papa Ours. « Allez, on y va, tout de suite ! »',
              '<span class="is-indent"></span>« Attends ! » dit Maman Ours,',
              '« j’ai un petit cadeau pour toi, ouvre-le vite ! »',
              '<span class="is-indent"></span>Petit Ours découvre alors une écharpe, noire et bleue.',
              '« Mes couleurs préférées ! » s’écrie Petit Ours heureux.'],
            bottom: ['Il pose devant le miroir, fier comme un paon.',
              '<span class="is-indent"></span><span class="is-large">« Allez viens »</span> dit Papa Ours en souriant,',
              '<span class="is-indent"></span>« sinon on sera en retard, mon grand. »']
          },
          2: {
            left: ['Ils voient dans la forêt Lapin.',
              'Il porte une écharpe lui aussi, tiens !',
              '<span class="is-indent"></span>Petit Ours demande : « On va lui dire bonjour, Papa ? »',
              '<span class="is-indent"></span>« Non ! Avec Lapin, c’est que des ennuis, crois-moi !',
              'Il massacre notre terrain comme on laboure un champ. »',
              '<span class="is-indent"></span>« Regarde son écharpe, <span class="is-large">elle est d’une autre couleur »</span>',
              'dit Papa Ours en grognant.'],
            right: ['<span class="is-large">« Viens, continuons notre chemin, »',
              'dit Papa Ours d’un ton décidé.',
              '« C’est ton premier match de foot, il ne faut rien rater. »']
          },
          3: {
            top: ['Le vent s’empare de l’écharpe de Papa Ours et la fait voler.',
              'Elle finit sa course dans un arbre, au sommet.',
              '<span class="is-spacer"></span>',
              '« Et maintenant ? » demande Papa Ours et il réfléchit un instant.',
              '<span class="is-indent"></span>« Chouette Hulotte ! » s’écrie Petit Ours.',
              '<span class="is-indent"></span>« Elle peut l’atteindre facilement. »',
              'Gonflant le poitrail, elle lui répond : «Et pourquoi devrais-je t’aider ? »',
              '<span class="is-indent"></span>« Cette écharpe est importante pour nous » explique Petit Ours étonné.',
              '<span class="is-indent"></span>« Allez d’accord, mais rien que pour cette fois. »',
              'Et elle jette l’écharpe à Papa Ours situé plus bas.',
              '<span class="is-indent"></span>« Je trouve Chouette Hulotte très sympa »',
              'dit Petit Ours de bonne humeur.',
              '« Non, tu ne peux pas » répond Papa Ours en grognant.',
              '« Regarde son écharpe, <span class="is-large">elle est d’une autre couleur. »</span>',
              '<span class="is-spacer"></span>',
              '<span class="is-indent"></span><span class="is-large">« Allez, on avance ! »</span> dit Papa Ours rapidement.',
              '<span class="is-indent"></span>« Sans quoi nous allons rater la première mi-temps ! »']
          },
          4: {
            top: ['Ils aperçoivent Zèbre galopant comme s’il faisait la course',
              'Une question trotte dans la tête de Petit Ours.',
              '<span class="is-indent"></span>« Papa, Zèbre, il est noir ou il est blanc ? »',
              '<span class="is-indent"></span>« Euh... » Papa Ours continue sa route en réfléchissant.',
              '<span class="is-spacer"></span>',
              '<span class="is-indent"></span>« Quelle excellente question » marmonne le Zèbre tout bas.',
              '« Je n’y fais pas attention, mon poil est comme ça.',
              'À toi de choisir. Noir ou blanc, je serai toujours beau. »',
              '<span class="is-indent"></span>« Peu importe » répond Petit Ours. « Ta peau, c’est ta peau. »',
              '« C’était pas malin de lui parler !',
              'Tu ne sais pas ce qui pourrait se passer. D’ailleurs, »',
              'réagit Papa Ours en grognant.',
              '<span class="is-indent"></span>« regarde son écharpe, <span class="is-large">elle est d’une autre couleur. »</span>'],
            bottom: ['<span class="is-large">« Viens, »</span> dit Papa Ours <span class="is-large">« Nous devons avancer.</span>',
              'Si ça continue, un but va déjà être marqué. »']
          },
          5: {
            left: ['<span class="is-indent"></span><span class="is-large">« Au secours ! »</span>',
              '<span class="is-indent"></span><span class="is-large">« Au secours ! »</span>',
              'Mais qui demande de l’aide ainsi ?',
              '<span class="is-indent"></span><span class="is-large">« Au secours ! »</span>',
              'On entend maintenant très bien d’où vient le cri.',
              'C’est Petit Buffle, qui arrive vers Petit Ours en courant.',
              '<span class="is-indent"></span><span class="is-large">« Au secours ! »</span>',
              '<span class="is-indent"></span>« Mon père est aveugle et ne voit plus rien maintenant ! »'],
            right: ['Papa Ours regarde ce qui se passe et se tord de rire.',
              'Mais Papa Buffle, pris de panique, ne cesse de gémir.',
              'Sur ses cornes des branches et des feuilles suspendues,',
              'sûrement portées par le vent, lui bloquent la vue.',
              '<span class="is-indent"></span>« Laisse-moi t’aider, » propose Petit Ours gentiment.',
              '<span class="is-indent"></span>« Voilà, Buffle. Tu peux voir, maintenant ! »',
              '« Buffle n’a pas besoin d’aide ! Je ne veux pas continuer à râler, »',
              'dit Papa Ours en ronchonnant.',
              '<span class="is-indent"></span>« Regarde son écharpe, <span class="is-large">ses couleurs, c’est différent. »</span>',
              '<span class="is-spacer"></span>',
              '<span class="is-indent"></span><span class="is-large">« Viens, on continue.</span> À force d’être si bavard,',
              '<span class="is-indent"></span>on va finir par être en retard. »’']
          },
          6: {
            top: ['Tout à coup, les ours entendent',
              'non loin de la rivière, une clameur.',
              '<span class="is-indent"></span><span class="is-large">« Le pont est cassé ! »</span>',
              'crient les animaux tous en cœur.',
              'Personne ne peut aller voir son match,',
              'toute la forêt est en colère.',
              'Tout le monde cherche querelle,',
              'personne ne sait quoi faire.']
          },
          7: {
            top: ['<span class="is-indent"></span>« Ma colère dépasse la vôtre ! »',
              'hurle Paon, à l’écharpe blanche et violette.',
              '« Mon équipe est la meilleure, vous n’êtes que des mauviettes. »',
              '<span class="is-indent"></span>« Même pas vrai ! »',
              'lui répond Coq arborant ses couleurs : le rouge et le blanc.',
              '« Mon équipe est la meilleure, on est des vrais battants. »',
              '<span class="is-spacer"></span>',
              'Tous les animaux crient et gesticulent comme des fous.',
              'Cela risque de mal finir, à tous les coups !',
              'On dirait qu’ils vont se battre, quel malheur.',
              '<span class="is-indent"></span>Regarde ces écharpes <span class="is-large">et toutes ces couleurs.</span>']
          },
          8: {
            top: ['« Comment peut-on aller voir',
              'notre match de foot maintenant ? »',
              '<span class="is-indent"></span>demande Petit Ours, <span class="is-large">les larmes aux yeux,</span>',
              '<span class="is-indent"></span>et reniflant.']
          },
          9: {
            top: ['Mais Papa Ours a une idée.',
              '<span class="is-indent"></span><span class="is-large">« Arrêtez, vous tous ! »</span>  rugit-il. « Écoutez ! »',
              'J’essaie de tous vous éviter constamment.',
              'Mais je vois que l’on se ressemble, c’est évident. »',
              '<span class="is-indent"></span>« Je ne ressemble quand même pas à Canari ! »',
              '<span class="is-indent"></span>s’exclame Paon, offusqué.',
              '« Regarde bien » lui conseille Papa Ours.',
              '« La même colère vous a tous les deux dévorés. »',
              '<span class="is-indent"></span>« Mais je n’ai pas de cornes comme Buffle ! » proteste Lapin.',
              '« Regarde bien » lui conseille Papa Ours.',
              '« Cette écharpe est ce que vous avez en commun. »',
              '« Les couleurs sont différentes, admettons,',
              'pourtant, c’est la même chose que nous tous désirons.',
              '<span class="is-indent"></span>Chaque animal, sans aucun doute, veut voir son match de foot. »'],
            bottom: ['Les animaux s’examinent sous toutes les coutures.',
              '<span class="is-indent"></span><span class="is-large">« Tu as bien raison, »</span> doivent-ils conclure.']
          },
          10: {
            top: ['Petit Ours offre à tous de coopérer.',
              '« Retirez tous votre écharpe et faites-la passer.',
              'En attachant les bouts les uns aux autres,',
              'nous passerons la rivière. »',
              '<span class="is-indent"></span>Et c’est ainsi qu’ils atteignent tous l’autre côté,',
              '<span class="is-indent"></span>tout fiers.'],
            bottom: ['<span class="is-indent"></span>Tout le monde est content.',
              'Et arrive pour voir le match juste à temps.',
              'Il se disent même - et c’est la vérité ! -',
              '<span class="is-large">« Amusez-vous bien ! »</span>',
              'comme si cela avait toujours été.']
          },
          11: {
            top: ['« Les autres couleurs ne posent pas de problème finalement ? »',
              'demande Petit Ours tout doucement.',
              '<span class="is-indent"></span>« Non, en effet, » répond Papa Ours.',
              'Et Petit Ours se met à rire de toutes ses dents.',
              '« Tout le monde peut avoir sa propre écharpe,',
              'c’est plus sympa. »',
              '« Mais <span class="is-large">le blue et noir</span> restent les plus belles couleurs, »',
              'se réjouit Papa.']
          },
          12: {
            top: ['« Nous sommes arrivés !',
              'Juste à temps, c’est incroyable !',
              '<span class="is-indent"></span>Bienvenue Petit Ours',
              'à ton premier match de foot <span class="is-large">inoubliable ! »</span>']
          }
        }
      }
    },

    /*
     *  ANIMATIONS
     */

    animation: {
      easing: 'easeInOutQuad',
      // easing: 'cubicBezier(.7, .005, .5, 1.005)',
      durationSmall: 1000,
      durationRegular: 2000,
      durationLarge: 3000,
      fadeInTime: 1000,
      fadeOutTime: 500
    }

  }
}
